import { createSvgComponent } from "../../icon/createSvgComponent";
import ShoppingBasket from "@core/__generated__/icon/figma/shopping-basket.svg";
export default createSvgComponent(ShoppingBasket);